import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { useAppContext } from 'src/contexts/AppContext';
import { useClientLogContext } from 'src/contexts/ClientLogContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { tryInvokeApi } from 'src/utils/tryExecuteUtils';
import { Feature, ReachProSupportCaseClient } from 'src/WebApiController';

export const SUPPORT_CASES_QUERY_KEY = 'reachpro-support-cases';

export function useReachProSupportCases() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();
  const { pathname } = useLocation();
  const hasReachProSupportFeature = useUserHasFeature(Feature.ReachProSupport);

  const isOnReachProPage = pathname.startsWith('/reachpro-support');
  const shouldQuery =
    hasReachProSupportFeature &&
    activeAccountWebClientConfig.activeAccountId != null &&
    isOnReachProPage;

  const {
    data: supportCases,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [
      SUPPORT_CASES_QUERY_KEY,
      activeAccountWebClientConfig.activeAccountId,
    ],
    queryFn: async () => {
      if (!shouldQuery) {
        return null;
      }
      return tryInvokeApi(
        async () => {
          return await new ReachProSupportCaseClient(
            activeAccountWebClientConfig
          ).getSupportCases();
        },
        (error) => {
          trackError('ReachProSupportCaseClient.getSupportCases', error);
        }
      );
    },
    enabled: shouldQuery,
    refetchInterval: shouldQuery ? 60000 : false,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });

  return {
    supportCases,
    isLoading,
    isError,
  };
}
